import {Component, EventEmitter, Input, Output} from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import {TranslationService} from '../../services/translation.service';
import {DeviceService} from '../../services/device.service';
import {inOutAnimation} from '../../animations';
import {ISymbol} from '../../models/ui/symbol';

@Component({
    selector: 'lv-label-tooltip',
    templateUrl: './labelTooltip.component.html',
    styleUrls: ['./labelTooltip.component.scss'],
    animations: [inOutAnimation],
    standalone: false
})
export class LabelTooltipComponent {
  @Input()
  public tooltip: string;

  @Input()
  public labelSymbol: ISymbol;

  @Input()
  public label: string;

  @Input()
  public isCollapsable: boolean;

  @Input()
  public isPflichtfeld: boolean;

  @Input()
  public showCursorAsPointer: boolean = false;

  @Output()
  public infotextCollapsableChange = new EventEmitter<boolean>();

  public showInfo: boolean = false;
  public mobile: boolean = false;

  constructor(private _snackBar: MatSnackBar,
              private _deviceService: DeviceService, private _translationService: TranslationService) {
    this.mobile = this._deviceService.isMobileDevice;
  }

  public toggleInfo() {
    this.showInfo = !this.showInfo;
    this.infotextCollapsableChange.emit(this.showInfo);
  }

  public onMobileClick() {
    if (this.mobile) {
      this._snackBar.open(this.tooltip, '', {
        duration: 5000,
        panelClass: 'lv-snackbar-mobile-label-tooltip'
      });
    }
  }
}
